<template>
  <div>
    <baseFrame saveText="" :submitText="able?'提交':''" clearText="" @submit="submit">
      <div slot="content">
        <lk-card title="收款信息" class="mb8">
          <lk-form :labelWidth='120' label-position="right" ref="formData" :rules='validate' :model='formData'>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="收款日期:" prop='proceedsTime'>
                  <timeStampDatePicker v-if="able" v-model="formData.proceedsTime">
                  </timeStampDatePicker>
                  <span v-else>{{ formData.proceedsTime |formatDate}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="收款方式:" prop='proceedsTypeId'>
                  <lk-select v-if="able" v-model="formData.proceedsTypeId">
                    <lk-option v-for="(item,i) in proceedsTypes" :key="i"
                      :value=item.proceedsTypeId>{{item.proceedsTypeName}}</lk-option>
                  </lk-select>
                  <span v-else>{{ formData.proceedsTypeName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="收款金额:" prop='proceedsAmount'>
                  <NumberInput size='default' v-if="able" v-model="formData.proceedsAmount" @on-blur="proceedsAmountChange" number></NumberInput>
                  <span v-else>{{ formData.proceedsAmount}}</span>
                </lk-form-item>
              </lk-col>

            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="购药人姓名:" prop='paymentUserName' ref="paymentUserName">
                  <lk-input v-if="able" v-model="formData.paymentUserName" :maxlength='100' :disabled="disabled">
                  </lk-input>
                  <span v-else>{{ formData.paymentUserName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="联系方式:" prop='paymentUserPhone' ref="paymentUserPhone">
                  <lk-input v-if="able" v-model="formData.paymentUserPhone" :disabled="disabled"></lk-input>
                  <span v-else>{{ formData.paymentUserPhone}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="已核销金额:">
                  <span>{{verificationTotal}}</span>
                </lk-form-item>
              </lk-col>

            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="已退款金额:">
                  <span>{{formData.refundAmount}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="退货退回金额:">
                  <span>{{ formData.returnAmount}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset='1'>
                <lk-form-item label="剩余预收款:">
                  <!-- 注释保留 -->
                  <!-- proceedsAmount - receivables - refundAmount - refundFrozenAmount + returnAmount -->
                  <!-- {{formData.proceedsAmount - formData.receivables - formData.refundAmount - formData.refundFrozenAmount + formData.returnAmount}} -->
                  <!-- <span>{{ formData.proceedsAmount?fixNumber(formData.proceedsAmount-allVerificationAmount):''}}</span> -->
                  <span>{{surplusTotal}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="核销明细">
          <div>
            <div class='mb8'>
              <lk-button type="primary" @click="handleModal" v-if="able">添加应收核销</lk-button>
            </div>
            <lk-table border :data='formData.financeDepositDetailVoList' :columns='checkColumns'></lk-table>
          </div>
        </lk-card>
        <lk-card title="退款明细">
          <div>
            <lk-table border :data='formData.financeDepositRefundList' :columns='cancelInfoCol'></lk-table>
          </div>
        </lk-card>
        <lk-card title="销售退货退回金额">
          <div>
            <lk-table border :data='formData.saleRefundList' :columns='refundCol'></lk-table>
          </div>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal
      v-model="modal"
      title="应收明细"
      :width="850"
      :mask-closable='false'
      @on-cancel="modalCancel"
      >
      <div>
        <div :gutter="16" class="queryParams mb8">
          <div>
            <span>销售订单号：</span>
            <lk-input style="width:200px" v-model="queryParams.orderNo"></lk-input>
          </div>
          <div>
            <span>业务时间：</span>
            <timeStampDatePicker style="width:200px" v-model="queryParams.createTime">
            </timeStampDatePicker>
          </div>
          <div>
            <lk-button type="primary" class="mr8" @click='getOrders'>查询</lk-button>
            <lk-button @click='clear'>重置</lk-button>
          </div>
        </div>
        <lk-table class='mb8' :data='orderList' :columns='orderCol' border
          @on-select='addSelecttion'
          @on-select-all='addSelecttion'
          @on-select-cancel="handleTempCancel"
          @on-select-all-cancel="handleTempCancelAll"
        ></lk-table>
        <lk-page style='text-align: right'   size="small" show-elevator show-sizer :total='queryParams.count'
          @on-change='handlePageChange'
          @on-page-size-change='handleSizeChange'
        ></lk-page>
      </div>
      <div class="modalFooter" slot="footer">
        <lk-button @click='handleCancelSelection'>取消</lk-button>
        <lk-button type='primary' @click='handleSelection'>确定</lk-button>
      </div>
    </lk-modal>
    <DTPModal
      v-model="changePatientInfo"
      :content="toastContent"
      @confirm="doChangePatientInfo"
      @handleCancel="cancelChangePatientInfo">
    </DTPModal>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import DTPModal from '../../components/DTPModal.vue';
import finance from '../../services/finance';
import system from '../../services/system';
// import loadingSpin from '../../components/LoadingSpan';

export default {
  name: 'PorceedInfoInfo',
  components: {
    baseFrame,
    DTPModal,
    // loadingSpin,
  },
  computed: {
    checkColumns() {
      if (!this.able) {
        return this.columns.filter(item => item.type !== 'operation');
      }
      return this.columns;
    },
    allVerificationAmount() {
      if (this.formData.financeDepositDetailVoList.length) {
        return utils.fixNumber(
          this.formData.financeDepositDetailVoList.map(item => item.verificationAmount).reduce((pre, cur) => pre + cur),
          2,
        );
      }
      return 0;
    },
    disabled() {
      const object = this.formData.financeDepositDetailVoList.find((item) => {
        if (item.relatePatientId) {
          return item.relatePatientId != '';
        }
      });
      return !!(this.formData.financeDepositDetailVoList.length) && !!object;
    },
    // proceedsTypeName() {
    //   return this.formData.proceedsTypeId ? this.proceedsTypes.find(item => item.proceedsTypeId === this.formData.proceedsTypeId).proceedsTypeName : '';
    // },
  },
  data() {
    return {
      verificationTotal: '', // 已核销金额
      surplusTotal: '', // 剩余预收款
      refundCol: [
        { title: '退货单号', key: 'code', minWidth: 116 },
        {
          title: '创建日期',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTimeToSecond(params.row.createTime))},
        {
          title: '审批通过日期',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTimeToSecond(params.row.modifiedTime)),
        },
        { title: '退回金额', key: 'amount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
      ],
      cancelInfoCol: [
        { title: '退款编号', key: 'code', minWidth: 116 },
        { title: '审批状态', key: 'approvalStatusName', minWidth: 116 },
        {
          title: '申请时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTimeToSecond(params.row.createTime)),
        },
        {
          title: '审批通过时间',
          key: 'approvalTime',
          minWidth: 116,
          render: (h, params) => h('span', params.row.approvalTime !== undefined ? utils.exchangeTimeToSecond(params.row.approvalTime) : ''),
        },
        { title: '发起人', key: 'createUserName', minWidth: 116 },
        { title: '退款方式', key: 'proceedsTypeName', minWidth: 116 },
        { title: '退款金额', key: 'amount', minWidth: 116 },
        { title: '退款原因', key: 'reason', minWidth: 116 },
      ],
      verificationTypeList: {
        1: '预收核销',
        2: '应收核销',
      },
      tempList: [],
      changePatientInfo: false,
      toastContent: '',
      constContent1: '应收核销购药人信息不一致，请重新选择',
      constContent2: '收款购药人信息和应收款购药人信息不匹配，是否更新收款购药人信息？',
      orderList: [
        // { type: 'selection', width: 60 },
      ],
      proceedsTypes: [

      ],
      orderCol: [
        { type: 'selection', width: 60 },
        { title: '销售订单号', key: 'orderCode', minWidth: 116 },
        { title: '创建日期', key: 'createTime', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '购药人姓名', key: 'buyerInfoDisplay', minWidth: 116 },
        { title: '商品', key: 'goodsInfo', minWidth: 116 },
        { title: '明细数量', key: 'goodsCountDisplay', minWidth: 116 },
        { title: '明细金额', key: 'amountWithoutDiscount', minWidth: 116 },
        { title: '剩余应收金额', key: 'receivablesAmount', minWidth: 116 },
      ],
      modal: false,
      queryParams: {
        page: 1,
        size: 10,
        count: 0,
      },

      formData: { financeDepositDetailVoList: [], proceedsTime: new Date().getTime() },
      validate: {
        proceedsTime: { required: true, message: '请选择收款日期', type: 'number' },
        proceedsTypeId: { required: true, message: '请选择收款方式', type: 'number' },
        proceedsAmount: {
          required: true,
          message: '请填写正确的收款金额',
          type: 'number',
          trigger: 'blur',
        },
        paymentUserName: {
          required: true,
          message: '请填写购药人姓名',
          type: 'string',
          trigger: 'blur',
        },
        paymentUserPhone: [
          {
            required: true,
            message: '请填写联系方式',
            trigger: 'blur',
          },
          {
            validator: utils.validate.cellPhoneValidator,
            trigger: 'blur',
          },
        ],
      },
      able: true,
      columns: [
        { title: '销售单号', key: 'orderCode', minWidth: 116 },
        { title: '创建日期', key: 'createTime', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '核销类型', key: 'verificationTypeStr', minWidth: 116 },
        { title: '核销日期', key: 'verificationDate', minWidth: 116 },
        { title: '购药人', key: 'buyerInfoDisplay', minWidth: 116 },
        { title: '商品', key: 'goodsInfo', minWidth: 116 },
        { title: '明细数量', key: 'goodsCountDisplay', minWidth: 116 },
        { title: '明细金额', key: 'amountWithoutDiscount', minWidth: 116 },
        { title: '剩余应收金额', key: 'realReceivablesAmount', minWidth: 116 },
        {
          title: '本次核销金额',
          key: 'verificationAmount',
          minWidth: 116,
          render: (h, { row, index }) => h('NumberInput', {
            props: {
              value: row.verificationAmount,
              max: row.realReceivablesAmount,
              disabled: !this.able || row.verificationType === 1,
            },
            on: {
              'on-blur': (val) => {
                this.formData.financeDepositDetailVoList[index].verificationAmount = val;
                this.refundDeposit();
              },
            },
          }),
        },
        {
          title: '操作',
          key: 'code',
          type: 'operation',
          minWidth: 116,
          render: (h, { row, index }) => h('div', [
            this.able && row.verificationType !== 1 ? h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.formData.financeDepositDetailVoList.splice(index, 1);
                  if (this.formData.financeDepositDetailVoList.length === 0) {
                    this.formData.paymentUserName = '';
                    this.formData.paymentUserPhone = '';
                  }
                  this.refundDeposit();
                },
              },
            }, '删除') : null,
          ]),
        },
      ],
    };
  },
  methods: {
    proceedsAmountChange() {
      this.refundDeposit();
    },
    refundDeposit() {
      const tempTotal = utils.fixNumber(this.formData.proceedsAmount - this.formData.refundAmount - this.formData.refundFrozenAmount + this.formData.returnAmount - this.totalVerificationAmount(), 2);
      this.surplusTotal = isNaN(tempTotal) ? 0 : tempTotal;
    },
    totalVerificationAmount() {
      if (this.formData.financeDepositDetailVoList.length) {
        this.verificationTotal = utils.fixNumber(
          this.formData.financeDepositDetailVoList.map(item => item.verificationAmount).reduce((pre, cur) => pre + cur),
          2,
        );
        return this.verificationTotal;
      }
      this.verificationTotal = 0;
      return 0;
    },
    fixNumber(num) {
      return utils.fixNumber(num, 2);
    },
    handleSelection() {
      if (this.checkRepeatName(this.tempList)) {
        this.isChangePatientInfo = false;
        // 如已填写购药人姓名和联系方式，且不匹配,则更新姓名和联系方式
        if (this.formData.paymentUserName || this.formData.paymentUserPhone) {
          if (this.tempList[0].relatePatientName !== this.formData.paymentUserName
              || this.tempList[0].relatePatientPhone !== this.formData.paymentUserPhone) {
            // 显示更新数据弹窗
            this.toastContent = this.constContent2;
            this.changePatientInfo = true;
          } else {
            this.formData.financeDepositDetailVoList = this.tempList;
            this.modal = false;
          }
        } else {
          this.formData.financeDepositDetailVoList = this.tempList;
          if (this.tempList[0]) {
            this.formData.paymentUserName = this.tempList[0].relatePatientName || '';
            this.formData.paymentUserPhone = this.tempList[0].relatePatientPhone || '';
            if (this.$refs.paymentUserName.validateMessage || this.$refs.paymentUserPhone.validateMessage) {
              this.$refs.paymentUserName.validateMessage = '';
              this.$refs.paymentUserName.validateState = '';
              this.$refs.paymentUserPhone.validateMessage = '';
              this.$refs.paymentUserPhone.validateState = '';
            }
          }
          this.modal = false;
        }
      } else {
        this.toastContent = this.constContent1;
        this.isChangePatientInfo = true;
        this.changePatientInfo = true;
      }
      this.refundDeposit();
    },
    handleCancelSelection() {
      this.tempList = this.formData.financeDepositDetailVoList;
      this.modal = false;
    },
    // 判断选择数组中的购药人姓名和电话是否一致
    checkRepeatName(array) {
      if (array.length < 2) {
        return true;
      }
      return array.every(item => (item.relatePatientName == array[0].relatePatientName
        && item.relatePatientPhone == array[0].relatePatientPhone));
    },
    addSelecttion(selection) {
      const exsitCodeArr = this.tempList.map(item => item.orderDetailId);
      const newSelection = selection.filter(item => !exsitCodeArr.includes(item.orderDetailId));
      this.tempList = this.tempList.concat(newSelection);
      this.refundDeposit();
    },
    handleTempCancel(row) {
      const tempListCodeArr = this.tempList.map(item => item.orderDetailId);
      const tempListIdx = tempListCodeArr.indexOf(row.orderDetailId);
      if (tempListIdx) {
        this.tempList.splice(tempListIdx, 1);
      }
    },
    handleTempCancelAll() {
      this.tempList = this.formData.financeDepositDetailVoList;
    },

    handleModal() {
      this.modal = true;
      this.getOrders();
    },
    submit() {
      if (this.surplusTotal * 1 < 0) {
        this.$Message.error('剩余预收款不能小于0');
        return;
      }
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.formData.deposit = this.surplusTotal;
          this.formData.receivables = this.allVerificationAmount;
          this.formData.financeDepositSaleOrderList = this.formData.financeDepositDetailVoList.map(item => ({
            orderCode: item.orderCode,
            saleOrderId: item.orderId,
            saleOrderDetailId: item.orderDetailId,
            verificationAmount: item.verificationAmount,
            verificationType: item.verificationType,
          }));

          this.formData.financeDepositId = this.formData.id;
          finance.submitFinanceDeposit(this.formData).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.$router.push({ name: 'proceed' });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    // 查看，编辑
    getData(financeDepositId) {
      finance.getFinanceDepositDetail({ financeDepositId }).then((res) => {
        if (res.data.status === 200) {
          this.formData = res.data.data;
          this.formData.financeDepositDetailVoList.forEach((item) => {
            item.orderCode = item.financeDepositDetail.saleOrderCode;
            item.orderId = item.saleOrderDetailProceedsVo.orderId;
            item.orderDetailId = item.saleOrderDetailProceedsVo.orderDetailId;
            item.createTime = utils.formatTime(item.financeDepositDetail.createTime);
            item.statusName = item.saleOrderDetailProceedsVo.statusName;
            item.buyerInfoDisplay = item.saleOrderDetailProceedsVo.buyerInfoDisplay;
            item.goodsInfo = item.saleOrderDetailProceedsVo.goodsInfo;
            item.goodsCountDisplay = item.saleOrderDetailProceedsVo.goodsCountDisplay;
            item.amountWithoutDiscount = item.saleOrderDetailProceedsVo.amountWithoutDiscount;
            item.receivablesAmount = item.saleOrderDetailProceedsVo.receivablesAmount;
            item.realReceivablesAmount = item.saleOrderDetailProceedsVo.realReceivablesAmount;
            item.verificationAmount = item.financeDepositDetail.verificationAmount;
            item.verificationDate = utils.formatTime(item.financeDepositDetail.verificationDate);
            item.verificationTypeStr = this.verificationTypeList[item.financeDepositDetail && item.financeDepositDetail.verificationType];
            item.verificationType = item.financeDepositDetail && item.financeDepositDetail.verificationType;
            // 编辑页面添加购药人姓名和手机号
            item.relatePatientPhone = item.saleOrderDetailProceedsVo.relatePatientPhone;
            item.relatePatientName = item.saleOrderDetailProceedsVo.relatePatientName;
          });
          this.tempList = this.formData.financeDepositDetailVoList;
          this.able = this.able && this.formData.allowEdit === 1;
          this.refundDeposit();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.queryParams = {
        page: 1,
        size: 10,
        count: this.queryParams.count,
      };
    },
    handlePageChange(page) {
      this.queryParams.page = page;
      this.getOrders();
    },
    handleSizeChange(size) {
      this.queryParams.size = size;
      this.getOrders();
    },
    getOrders() {
      const params = utils.deepClone(this.queryParams);
      params.needReceivables = 1;
      params.withoutProceeds = false;
      this.orderList = [];
      finance.getFinanceProceedsListOrder(params).then((res) => {
        if (res.data.status === 200) {
          this.queryParams.count = res.data.data.count;
          this.orderList = res.data.data.list.map((item) => {
            item._checked = this.tempList.map(temp => temp.orderDetailId).includes(item.orderDetailId);
            item._disabled = item._checked;
            item.verificationAmount = item.receivablesAmount;
            item.createTime = utils.formatDate(item.createTime);
            item.verificationType = 2;
            item.verificationTypeStr = '应收核销';
            item.verificationDate = utils.formatDate(new Date().getTime());

            return item;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleProceedsTypes() {
      system.getEnableProceedsType().then((res) => {
        this.proceedsTypes = res.filter(item => !item.proceedsTypeFlag || !item.proceedsTypeFlag === 'deposit');
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    doChangePatientInfo() {
      if (!this.isChangePatientInfo) {
        this.formData.financeDepositDetailVoList = this.tempList;
        this.formData.paymentUserName = this.tempList[0].relatePatientName || '';
        this.formData.paymentUserPhone = this.tempList[0].relatePatientPhone || '';
        this.modal = false;
      }
      this.changePatientInfo = false;
    },
    cancelChangePatientInfo() {
      this.changePatientInfo = false;
    },
    // modal关闭
    modalCancel() {
      this.tempList = this.formData.financeDepositDetailVoList;
    },
  },
  mounted() {
    this.handleProceedsTypes();
    this.able = this.$route.name !== 'proceedCheck';
    this.$route.params.id && this.getData(this.$route.params.id);
    if (this.$route.name == 'proceedAdd') {
      this.formData.refundAmount = 0;
      this.formData.refundFrozenAmount = 0;
      this.formData.receivables = 0;
      this.formData.returnAmount = 0;
    }
  },
};

</script>
<style lang="less" >
.PaymentOrders .noEqual{
  color: #FF4D07
}
.queryParams{
  display:flex;
  flex-shrink: 1;
  >div{
    width: 300px;
  display:flex;
  align-items: center;
  }
}
</style>
